import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-taboola-section',
  templateUrl: './taboola-section.component.html',
  styleUrls: ['./taboola-section.component.scss']
})
export class TaboolaSectionComponent implements OnInit {
  ngOnInit(): void {
    if (typeof window !== "undefined") {
      (window as any)._taboola = (window as any)._taboola || [];
      (window as any)._taboola.push({
        mode: 'alternating-thumbnails-a',
        container: 'taboola-below-article-thumbnails',
        placement: 'Below Article Thumbnails',
        target_type: 'mix'
      });
    }
  }
}
